import { IArea } from 'store/entities/configuration/configurationModel';

export const areaView = (area?: IArea) => area ? `${area.id} (${area.description})` : '';
